module.exports = __webpack_public_path__ + "static/ruby3-e9ad6e2713e24d023d1a3ef4d67db3a6.png";